import { defineToolSpec, type ToolComponent } from "@zapier/ai-toolkit";
import { z } from "zod";

import {
  PlanRequirements as PlanRequirementsContainer,
  type PlanRequirementsProps,
} from "@zapier/templates";

export type PlanRequirementsOutput = PlanRequirementsProps["requirements"];

const parameters = z.object({
  templateSlug: z
    .string()
    .describe("The slug of the template to check the requirements for."),
});

export type PlanRequirementsArgs = z.infer<typeof parameters>;

// Tool specification
export const planRequirementsTool = defineToolSpec({
  name: "planRequirements",
  description:
    "Tells the user if their current plan meets the requirements for a template.",
  parameters,
  resultType: {} as PlanRequirementsOutput, // Type for the result
});

export const PlanRequirementsComponent: ToolComponent<
  typeof planRequirementsTool
> = ({ result }) => {
  if (!result) return null;

  return <PlanRequirementsContainer requirements={result} />;
};
